import { Link as MuiLink } from '@mui/material';
import { Box } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type Props = {
  fileType: string;
  fileUrl: string;
  isPreview?: boolean;
};

export function ImportantDocumentThumbnail({
  fileType,
  fileUrl,
  isPreview,
}: Props) {
  const thumbnailWidth = '64px';
  const imageAlt = isPreview
    ? '重要書類のプレビュー画像'
    : '重要書類のサムネイル画像';

  const svgSx = {
    fontSize: '3rem',
    color: 'text.secondary',
  };
  const SvgBox = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        border: '1px solid #ddd',
      }}
    >
      {fileType === 'pdf' ? (
        <PictureAsPdfIcon sx={svgSx} />
      ) : (
        <FileDownloadIcon sx={svgSx} />
      )}
    </Box>
  );
  const ImageBox = (
    <Box
      component="img"
      src={fileUrl}
      alt={imageAlt}
      sx={{
        objectFit: 'cover',
        maxWidth: '100%',
        width: thumbnailWidth,
        height: thumbnailWidth,
      }}
    />
  );

  return (
    <MuiLink
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'block',
        width: thumbnailWidth,
        height: thumbnailWidth,
      }}
    >
      {fileType === 'image' ? ImageBox : SvgBox}
    </MuiLink>
  );
}
